export default "__VITE_ASSET__Bq0bA_JI__"